import leads from './leads'

export default {
  leads,
}
